var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.ValidationObserver, {
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "email-step",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return handleSubmit(_setup.submit)
                  },
                },
              },
              [
                _c("p", { staticClass: "email-step-intro" }, [
                  _vm._v(
                    "\n            Etsy did not share an email address with us. Tell us where to reach you and we'll finish your account.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(_setup.ValidationProvider, {
                  attrs: { rules: "required|email", name: "Email" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ errors }) {
                          return [
                            _c(_setup.CInput, {
                              attrs: {
                                type: "email",
                                label: "Email",
                                placeholder: "Type your email",
                                error: !!errors[0],
                                "error-msg": errors[0],
                              },
                              model: {
                                value: _setup.email,
                                callback: function ($$v) {
                                  _setup.email = $$v
                                },
                                expression: "email",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _setup.errorMessage
                  ? _c(_setup.CError, {
                      attrs: { message: _setup.errorMessage },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-actions" },
                  [
                    _c(_setup.CButton, {
                      attrs: {
                        variant: "outline-secondary",
                        text: "Back",
                        disabled: _setup.submitting,
                      },
                      on: {
                        click: function ($event) {
                          return _setup.emit("back")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(_setup.CButton, {
                      attrs: {
                        type: "submit",
                        variant: "primary",
                        text: _setup.submitting
                          ? "Creating your account..."
                          : "Continue",
                        disabled: _setup.submitting,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }